(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/table-of-score-parts/event-row-outcomes.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/table-of-score-parts/event-row-outcomes.js');
"use strict";


const {
  ScoreOutcomesColumn
} = svs.components.sport.quickplayModal.tableOfScoreParts;
const {
  productIds
} = svs.utils.products;
const {
  OutcomePair
} = svs.components.lbUi;
const EventRowOutcomes = _ref => {
  var _eventResults, _eventResults2, _eventResults3;
  let {
    eventIndex,
    pixData,
    productId
  } = _ref;
  let eventResults = {};
  if (productId === productIds.BOMBEN) {
    var _pixData$signsByEvent;
    eventResults = (pixData === null || pixData === void 0 || (_pixData$signsByEvent = pixData.signsByEventForOutput) === null || _pixData$signsByEvent === void 0 || (_pixData$signsByEvent = _pixData$signsByEvent.bomben) === null || _pixData$signsByEvent === void 0 ? void 0 : _pixData$signsByEvent[eventIndex]) || [];
  }
  return React.createElement("div", {
    className: "u-flex u-flex-justify-content-between f-100 fc-white qp_score__outcomes"
  }, React.createElement(ScoreOutcomesColumn, null, React.createElement(ScoreOutcomesColumn.Header, null, "Hemmavinst"), (_eventResults = eventResults) === null || _eventResults === void 0 || (_eventResults = _eventResults.homeWin) === null || _eventResults === void 0 ? void 0 : _eventResults.map(_ref2 => {
    let [labelOne, labelTwo] = _ref2;
    return React.createElement(ScoreOutcomesColumn.Row, {
      className: "qp_score__row--left-align",
      key: "score_outcome_row_".concat(eventIndex, "_").concat(labelOne, "_").concat(labelTwo)
    }, React.createElement(OutcomePair, {
      outcomeAway: labelTwo,
      outcomeHome: labelOne
    }));
  })), React.createElement(ScoreOutcomesColumn, null, React.createElement(ScoreOutcomesColumn.Header, null, "Oavgjort"), (_eventResults2 = eventResults) === null || _eventResults2 === void 0 || (_eventResults2 = _eventResults2.draw) === null || _eventResults2 === void 0 ? void 0 : _eventResults2.map(_ref3 => {
    let [labelOne, labelTwo] = _ref3;
    return React.createElement(ScoreOutcomesColumn.Row, {
      key: "score_outcome_row_".concat(eventIndex, "_").concat(labelOne, "_").concat(labelTwo)
    }, React.createElement(OutcomePair, {
      outcomeAway: labelTwo,
      outcomeHome: labelOne
    }));
  })), React.createElement(ScoreOutcomesColumn, null, React.createElement(ScoreOutcomesColumn.Header, null, "Bortavinst"), (_eventResults3 = eventResults) === null || _eventResults3 === void 0 || (_eventResults3 = _eventResults3.awayWin) === null || _eventResults3 === void 0 ? void 0 : _eventResults3.map(_ref4 => {
    let [labelOne, labelTwo] = _ref4;
    return React.createElement(ScoreOutcomesColumn.Row, {
      className: "qp_score__row--right-align",
      key: "score_outcome_row_".concat(eventIndex, "_").concat(labelOne, "_").concat(labelTwo)
    }, React.createElement(OutcomePair, {
      outcomeAway: labelTwo,
      outcomeHome: labelOne
    }));
  })));
};
setGlobal('svs.components.sport.quickplayModal.tableOfScoreParts.EventRowOutcomes', EventRowOutcomes);

 })(window);